interface Link {
  label: string
  link: string
  isSocial?: boolean
}

interface Section {
  label: string
  links: Link[]
}

const sections: Section[] = [
  {
    label: 'Company',
    links: [
      // Removed waiting for copy
      // { label: 'About Us', link: '/about-us' },
      { label: 'Meet the Team', link: '/team' },
      { label: 'Meet the Experts', link: '/meet-the-experts' }
    ]
  },
  {
    label: 'Help',
    links: [
      { label: 'How it works', link: '/how-it-works' },
      { label: 'Customer Support', link: '/support' },
      { label: 'Return Policy', link: '/returns' },
      { label: 'Frequently Asked Questions', link: '/faq' }
    ]
  },
  {
    label: 'Legal',
    links: [
      { label: 'Privacy Policy', link: '/legal/privacy-policy' },
      { label: 'Terms and Conditions', link: '/legal/terms-conditions' }
    ]
  },
  {
    label: 'Social',
    links: [
      { label: 'Facebook', link: 'facebook', isSocial: true },
      { label: 'Instagram', link: 'instagram', isSocial: true }
    ]
  }
]

export default sections

export const links = sections.reduce<Link[]>((prev, { links }) => [...prev, ...links] as Link[], [])
